import { create } from "zustand";
import { ELanguage, IUserDetails, IUserStore } from "./store";

export const useUserStore = create<IUserStore>(() => ({
  userDetails: undefined,
}));

export function dispatchUserDetails(
  userDetails: IUserDetails,
  language: ELanguage,
) {
  const state = useUserStore.getState();
  useUserStore.setState({ ...state, userDetails });
}